/* eslint-disable max-statements */
/* eslint-disable camelcase */

import { getPayerId } from './payerId-helper';

const getFptiValues = (options) => {
  const componentTags = {
    button_label: options.buttonName,
    link_name: options.link,
    event_name: `${options.page}::${options.eventName}`,
    redirect_url: options.redirectUrl,
    field_name: options.fieldName,
    campaign_id: options.campaignId,
    page: `main:merchant-lending:ppbl::${options.page}::`,
    message: options?.message,

  };
  const payerId = getPayerId();
  const genericTags = {
    pgrp: `main:merchant-lending:ppbl::${options.page}::`,
    pgln: options?.link ? `main:merchant-lending:ppbl::${options?.page}::${options?.link}` : undefined,
    cust_id: payerId,
  };

  let errorTags = {};

  if (options.error) {
    errorTags = {
      erpg: options.error,
      erfd: options.link,
    };
  }
  return {
    ...componentTags,
    ...genericTags,
    ...errorTags,
  };
};

function recordFpti(type, data) {
  const analytics = window?.PAYPAL?.analytics;
  const instance = analytics?.instance || analytics?.AnalyticsInstance || analytics?.Analytics?.prototype || analytics;
  const methodName = type === 'click' ? 'recordClick' : 'recordImpression';
  const recordFn = instance && instance[methodName];

  if (typeof recordFn === 'function') {
    try {
      recordFn.call(instance, { data });
    }
    catch (_) {
      try {
        recordFn.call(instance, data);
      }
      catch (__) {
        // silently fail
      }
    }
  }
}

function recordClick(data) {
  recordFpti('click', data);
}

function recordImpression(data) {
  recordFpti('impression', data);
}

function trackClick(fptiData) {
  const options = getFptiValues(fptiData);
  if (options.cust_id) {
    recordClick(options);
  }
}

function trackPage(fptiData) {
  const options = getFptiValues(fptiData);
  if (options.cust_id) {
    recordImpression(options);
  }
}

function trackError(fptiData) {
  const options = getFptiValues(fptiData);
  if (options.cust_id) {
    recordImpression(options);
  }
}

export {
  trackClick,
  trackPage,
  trackError,
};
